var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('tab-header-customer-id'),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active show"},[_c('customer-id-content')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }